import { FFprobeWorker } from "ffprobe-wasm";

let ffprobeInstance: FFprobeWorker | null = null;
let loadingPromise: Promise<FFprobeWorker> | null = null;
let isLoaded = false;

/**
 * Get the singleton FFprobe instance, loading it if necessary.
 * This can be called multiple times safely - it will return the same instance.
 */
export async function getFFprobe(): Promise<FFprobeWorker> {
  // If already loaded, return immediately
  if (isLoaded && ffprobeInstance) {
    return ffprobeInstance;
  }

  // If currently loading, wait for that promise
  if (loadingPromise) {
    return loadingPromise;
  }

  // Start loading
  loadingPromise = (async () => {
    try {
      console.log("[FFprobe] Checking SharedArrayBuffer availability...");
      console.log("[FFprobe] SharedArrayBuffer available?", typeof SharedArrayBuffer !== "undefined");
      console.log("[FFprobe] crossOriginIsolated?", crossOriginIsolated);

      console.log("[FFprobe] Initializing...");
      ffprobeInstance = new FFprobeWorker();
      isLoaded = true;
      console.log("[FFprobe] Loaded successfully");
      return ffprobeInstance;
    } catch (error) {
      console.error("[FFprobe] Failed to load:", error);
      loadingPromise = null; // Reset so we can retry
      throw error;
    }
  })();

  return loadingPromise;
}

/**
 * Preload FFprobe in the background.
 * Call this early (e.g., on app mount) to have it ready when needed.
 */
export function preloadFFprobe(): void {
  // Start loading in the background, but don't await it
  getFFprobe().catch((error) => {
    console.error("[FFprobe] Preload failed:", error);
  });
}

/**
 * Check if FFprobe is ready to use (without triggering a load).
 */
export function isFFprobeReady(): boolean {
  return isLoaded && ffprobeInstance !== null;
}
